'use client';

import { useEffect, useState } from 'react';
import { useMediaQuery } from '@mui/material';

export function Desktop(props: any): JSX.Element | null {
  const matches = useMediaQuery('(min-width:900px)');
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted || !matches) return null;
  return props.children;
}
